import { RevisionSystemConfig } from '../../revision-system/config/RevisionSystemConfig';

/**
 * Configuration for the General Revision System
 * 
 * This configuration object customizes the shared revision system core
 * for general-purpose learning with the following settings:
 * - Collections: general-sections, general-cards, general-reviews
 * - Routing: /general-revision/*
 * - Migration: Exclude sections starting with "Greek " (migrate all others)
 * - UI: Exclude Greek Input component (not needed for general content)
 */
export const generalConfig: RevisionSystemConfig = {
  collections: {
    sections: 'general-sections',
    cards: 'general-cards',
    reviews: 'general-reviews'
  },
  
  routing: {
    basePath: '/general-revision'
  },
  
  migration: {
    legacyCollection: 'sections',
    sectionNameFilter: (name: string) => !name.startsWith('Greek ')
  },
  
  ui: {
    includeGreekInput: false,
    systemName: 'General Revision'
  }
};
